import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer, mergeAttributes } from "@tiptap/react";
import { Renderer } from "./Renderer";

export const FileExtension = Node.create({
  name: "file",
  group: "block",
  atom: true,
  addAttributes: () => ({
    signed_id: {
      default: null,
    },
  }),
  parseHTML: () => [{ tag: "file-react" }],
  renderHTML: ({ HTMLAttributes }) => [
    "file-react",
    mergeAttributes(HTMLAttributes),
  ],
  addNodeView: () => props => {
    const nodeView = ReactNodeViewRenderer(Renderer)(props);
    const originalStopEvent = nodeView.stopEvent;

    // Fixes issues changing video playback position in Firefox and Safari
    nodeView.stopEvent = event => {
      if (
        event.target &&
        ["VIDEO", "MEDIA-THEME"].includes(event.target.tagName)
      ) {
        return true;
      }
      return originalStopEvent(event);
    };

    return nodeView;
  },
});
